import * as React from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';
import UploadMovie from './UploadMovie';


export default function UploadFile() {

   return (<UploadMovie></UploadMovie>)
}






